import primary from './primary';
import disabled from './disabled';
import dark from './dark';
import white from './white';
import simple from './simple';
import icon from './icon';
import buttons from '@solid-ui-theme/buttons';

export default {
  primary,
  disabled,
  dark,
  white,
  simple,
  icon,
  secondary: buttons.secondary,
};
